import React from "react";
import { Button } from "antd";
import { localStorageVariableName } from "swfrontend/AppConfigs";
import TimeLine from "./CustomTimeline";
import TandC from "./TandC";

class CustomFooter extends React.Component {
  render() {
    const { isInEdit, handleTC, isStaff } = this.props;

    return (
      <>
        {!isInEdit && !isStaff && <TandC onChange={handleTC} />}

        {!isInEdit && !isStaff && (
          <div className="text-center">
            <Button htmlType="submit" type="primary" id="submit">
              Submit
            </Button>{" "}
            &nbsp;&nbsp;&nbsp;
            <Button htmlType="reset" type="default">
              Reset
            </Button>
          </div>
        )}
      </>
    );
  }
}

export default CustomFooter;
